import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { ToastresService } from 'src/app/helpers/services/toaster.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent {
  public user: any;
  public client: any;
  form: FormGroup;
  submitted: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public httpService: HttpService,
    private api: ApiService,
    private toastrsService: ToastresService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  get f() {
    return this.form.controls;
  }

  submit() {
    this.submitted = true;
    if (this.form.valid) {
      let payload = {
        new_password: this.f.NewPassword.value,
        confirm_password: this.f.ConfirmPassword.value,
      };

      let apiUrl = this.client
        ? this.api.clients.resetPassword(this.client.id)
        : this.api.users.resetPassword(this.user.id);
      this.httpService
        .action(apiUrl, payload, 'resetPasswordLoader')
        .subscribe({
          next: (res: any) => {
            if (res.success) {
              this.activeModal.close();
              this.toastrsService.ShowSuccess(res.msg);
            } else {
              this.toastrsService.ShowError(res.msg);
            }
          },
        });
    }
  }

  initForm() {
    this.form = new FormGroup({
      NewPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
      ]),
      ConfirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
      ]),
    });
  }
}
